import Styles from './UploadsDrawer.module.scss'
import { UploadedFile } from '../UploadedFile'
import { useUploadsTab } from '../UploadsTabContext'
import { Carousel } from 'components/Carousel/Carousel'
import { SectionHeader } from './SectionHeader'
import { BrandKit as BrandKitType } from 'types'

interface Props {
  brandKit: BrandKitType
}

export const BrandKit = ({ brandKit }: Props) => {
  const { openPanel } = useUploadsTab()

  return (
    <div>
      <SectionHeader
        title={brandKit?.name || 'Brand Kit'}
        onPress={() =>
          setTimeout(
            () => openPanel({ panel: 'brandKit', panelProps: { brandKitId: brandKit.id, title: brandKit.name } }),
            100,
          )
        }
      />
      <div className={Styles.sectionContainer}>
        <Carousel slideGap={7}>
          {brandKit.media_files.slice(0, 6).map((file, index) => (
            <div key={index} className={Styles.mediaFileContainer}>
              <UploadedFile
                key={file.id}
                file={{ ...file, variants: [], mime_type: 'image/png' }}
                size={{ height: 100, width: 100 }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}
